<div
  class="tournamentTunerMainContainer"
>

  <app-cross-close-button>
  </app-cross-close-button>

  <app-tournament-tuner-type-checkboxes>
  </app-tournament-tuner-type-checkboxes>

  <app-tournament-tuner-groups-part
    *ngIf="displayGroupsOptions()"
  >
  </app-tournament-tuner-groups-part>

  <app-ordinary-grid-types-list
    *ngIf="displayConventionalGrid()"
  >
  </app-ordinary-grid-types-list>

  <app-ordinary-grid-types-list
    *ngIf="displayConventionalGridTypesWithGroups()"
  >
  </app-ordinary-grid-types-list>

</div>
